import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreService } from '@morningstar/shared/base/base-service';
import { environment } from '@morningstar/shared/environment';
import { HttpParamsHelper } from '@morningstar/shared/util';
import { RevenueTotalOptions } from '../revenue-total/revenue-total-options';
import { RevenueByCategoryDatum } from './revenue-by-category-datum';
import { TwoMonthCompare } from './two-month-compare/two-month-compare';

@Injectable()
export class RevenueByCategoryService extends StoreService {

  constructor(protected httpClient: HttpClient,
              snackbar: MatSnackBar,
              @Inject('API_BASE_URL') private baseHref) {
    super(httpClient, baseHref, snackbar);
  }

  get(location: string, options: RevenueTotalOptions) {
    return this.httpClient.get<RevenueByCategoryDatum[]>(this.baseHref + environment.api.dashboard.categoryTrend.donut.replace('{location}', location), {
      params: HttpParamsHelper.mapToQueryParams<RevenueTotalOptions>(options)
    });
  }

  getTwoMonthCompare(location: string, firstPeriod: string, secondPeriod: string) {
    const endpoint = `dashboard/two-month-compare?location=${location}&firstPeriod=${firstPeriod}&secondPeriod=${secondPeriod}`;
    return this.read<TwoMonthCompare[]>('twoMonthCompare', endpoint, 'two month compare');
  }
}
